import React, { useState } from 'react'
import { 
  Card, 
  Grid, 
  IconButton, 
  Typography, 
  useTheme,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button 
} from '@mui/material'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import OpenInFullOutlinedIcon from '@mui/icons-material/OpenInFullOutlined';
import { useNavigate } from 'react-router-dom';

function RecipeListCard({
  recipeTitle,
  id,
  imageSrc,
  handleDeleteRecipe // Add this prop to handle delete functionality
}) {

  const theme = useTheme();
  const navigate = useNavigate();
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);

  const handleEdit = () => {
    navigate(`/edit-recipe-details/${id}`);
  };

  const handleDeleteClick = () => {
    setOpenDeleteDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDeleteDialog(false);
  };

  const handleConfirmDelete = () => {
    handleDeleteRecipe(id); // Call the delete function passed as prop
    setOpenDeleteDialog(false);
  };

  return (
    <>
      <Card
        sx={{
          width: '95%',
          height: '8rem',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '0.5rem',
          marginBottom: '1rem',
          flexShrink: 0
        }}
      >
        <Grid item sx={{ flex: '1', height: '100%', width: '5rem', marginRight: '1rem' }}>
          <img alt='recipe photo' src={imageSrc}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              display: 'block',
              borderRadius: '1rem',
            }}
          />
        </Grid>
        <Grid container sx={{ flex: '4', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', height: '100%' }}>
          <Grid item flex={'1'} display={'flex'} justifyContent={'flex-start'} alignItems={'center'}>
            <Typography variant='primary' fontWeight={700} fontSize={'1.25rem'}>
              {recipeTitle}
            </Typography>
          </Grid>
          <Grid item flex={'1'}>
            <IconButton
              height={50}
              width={50}
              sx={{ 
                color: `${theme.palette.primary.main}`,
                backgroundColor: `${theme.palette.secondary.main}`,
                marginRight: '1rem'
              }}
              onClick={handleEdit}
            >
              <OpenInFullOutlinedIcon />
            </IconButton>
            {/* <IconButton
              height={50}
              width={50}
              variant='contained'
              sx={{ 
                color: `${theme.palette.primary.main}`,
                backgroundColor: `${theme.palette.secondary.main}`,
                marginRight: '1rem'
              }}
            >
              <BarChartOutlinedIcon />
            </IconButton> */}
            <IconButton
              height={50}
              width={50}
              variant='contained'
              sx={{ 
                color: `${theme.palette.primary.main}`,
                backgroundColor: `${theme.palette.secondary.main}`,
              }}
              onClick={handleDeleteClick}
            >
              <DeleteOutlineOutlinedIcon />
            </IconButton>
          </Grid>
        </Grid>
      </Card>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={openDeleteDialog}
        onClose={handleCloseDialog}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">
          {"Delete Recipe"}
        </DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete "{recipeTitle}"? This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button 
            onClick={handleCloseDialog} 
            color="primary"
          >
            Cancel
          </Button>
          <Button 
            onClick={handleConfirmDelete} 
            color="error" 
            variant="contained"
            autoFocus
          >
            Confirm Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default RecipeListCard;